function getElementDocument(element) {
    return (null == element ? void 0 : element.ownerDocument) || null;
}
function getElementWindow(element) {
    var _getElementDocument;
    return (null == (_getElementDocument = getElementDocument(element)) ? void 0 : _getElementDocument.defaultView) || null;
}
function isDOMElement(element) {
    const elementWindow = getElementWindow(element);
    return !!elementWindow && element instanceof HTMLElement;
}
function isFunction(value) {
    return 'function' == typeof value;
}
function findLastIndex(array, predicate) {
    for(let i = array.length - 1; i >= 0; i--){
        const x = array[i];
        if (predicate(x, i)) return i;
    }
    return -1;
}
function repeat(string, n = 1) {
    let result = '';
    for(let i = 0; i < n; i++)result += string;
    return result;
}
function helpers_toString(value) {
    return `${value}`;
}
export { findLastIndex, getElementDocument, getElementWindow, helpers_toString as toString, isDOMElement, isFunction, repeat };
